/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_UpdateInputs */

const vi_common_update = /** @type {(inputs: Common_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật`)
};

/**

* @param {Common_UpdateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_update = /** @type {((inputs?: Common_UpdateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_UpdateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_update(inputs)
});